import { createStore } from 'vuex'
import data from '@/data/db.json';

// Create a new store instance.
const store = createStore({
    state: {
        authenticated: false,
        persons: "",
        space: "",
        coldRentWithoutNk: "",
        coldRentWithoutHeatingCost: "",
        garageCost: "",
        energy: false,
        data: data
    },
    mutations: {
        setAuthentication(state, status) {
            state.authenticated = status;
        },
        setPersons(state, status) {
            state.persons = status;
        },
        setSpace(state, status) {
            state.space = status;
        },
        setColdRentWithoutNk(state, status) {
            state.coldRentWithoutNk = status;
        },
        setColdRentWithoutHeatingCost(state, status) {
            state.coldRentWithoutHeatingCost = status;
        },
        setGarageCost(state, status) {
            state.garageCost = status;
        },
        setEnergy(state, status) {
            state.energy = status;
        },
    }
})

export default store;